import { axiosClient } from '../network/appClient';
import { useToken } from '../store/auth/tokenStore';
import type { CalendarPricesResponseDTO } from "../DTO/calendarResponseDTO"

const fetchPrices = async (
    productId: number | string,
    rangeStart: Date,
    rangeEnd: Date
): Promise<CalendarPricesResponseDTO> => {
    const response = await axiosClient.get('Sale/Product/PriceCalendar', {
        headers: {
            Authorization: `Bearer ${useToken.getState().token}`,
        },
        params: {
            ProductId: productId,
            StartsAt: rangeStart.toISOString(),
            EndsAt: rangeEnd.toISOString(),
        },
    });
    const prices = response.data as CalendarPricesResponseDTO;

    return prices;
};

const calendarServices = { fetchPrices };

export default calendarServices;
